/**
 * <EstadiaCodeTag> — Tag visual del "Código de estadía AF" (#N).
 *
 * Fuente única del estilo del código de estadía en toda la app (color geekblue +
 * ícono de vínculo). Reusar en cualquier superficie que muestre el código para
 * mantener consistencia visual. Ver utils/estadiaCode.ts y docs/glosario.md.
 *
 * Uso:
 *   - Tablas densas → `withTooltip={false}` (el tooltip explicativo va una sola
 *     vez, en el header de la columna) para no montar N tooltips.
 *   - Modales / tarjetas / tooltips de barra → con tooltip (default).
 *   - Devuelve `null` si `id == null` (no rompe el layout; ej. aseo aledaño).
 */

import { Tag, Tooltip } from "antd";
import { LinkOutlined } from "@ant-design/icons";
import {
  ESTADIA_SHORT,
  ESTADIA_TOOLTIP,
  formatEstadiaCode,
} from "../utils/estadiaCode";

interface EstadiaCodeTagProps {
  id?: number | string | null;
  /** Mostrar el tooltip explicativo. Default true. Usar false en celdas de tabla. */
  withTooltip?: boolean;
  /** Estilo extra opcional para el Tag. */
  style?: React.CSSProperties;
}

export default function EstadiaCodeTag({
  id,
  withTooltip = true,
  style,
}: EstadiaCodeTagProps) {
  if (id == null || id === "") return null;

  const tag = (
    <Tag
      color="geekblue"
      icon={<LinkOutlined />}
      style={{ marginInlineEnd: 0, ...style }}
    >
      {ESTADIA_SHORT} {formatEstadiaCode(id)}
    </Tag>
  );

  return withTooltip ? <Tooltip title={ESTADIA_TOOLTIP}>{tag}</Tooltip> : tag;
}
